import type { IntlShape } from "react-intl";

// A failed save's HTTP status as the thing the admin can fix: not signed in, not an admin, feature not
// configured, or the config store failing. Shared by the cards that save to gemstone through /ai/*.
// `code` is the BFF's `error` field; it names the 400s the model-config route refuses on purpose.
export function modelConfigSaveErrorMessage(intl: IntlShape, status: number, code?: string): string {
  if (status === 400 && code === "api_key_required")
    return intl.formatMessage({
      id: "model.saveError.apiKeyRequired",
      defaultMessage: "Enter an API key for this provider before activating it.",
    });
  if (status === 400 && code === "provider_not_servable")
    return intl.formatMessage({
      id: "model.saveError.providerNotServable",
      defaultMessage: "This provider isn't supported yet – choose another one.",
    });
  switch (status) {
    case 401:
      return intl.formatMessage({
        id: "model.saveError.unauthorized",
        defaultMessage: "Your session has expired – sign in again.",
      });
    case 403:
      return intl.formatMessage({
        id: "model.saveError.forbidden",
        defaultMessage: "You need admin rights to change the model configuration.",
      });
    case 501:
      return intl.formatMessage({
        id: "model.saveError.notConfigured",
        defaultMessage: "Model configuration isn't enabled on this server.",
      });
    case 502:
      return intl.formatMessage({
        id: "model.saveError.upstream",
        defaultMessage: "Couldn't reach the configuration store – try again.",
      });
    default:
      return intl.formatMessage({
        id: "model.saveError",
        defaultMessage: "Couldn't save model settings – try again.",
      });
  }
}
